import { makeStyles } from "tss-react/mui";
import type { SelectChangeEvent } from "@mui/material/Select";
import { MiInputSelectBox } from "../MiInputSelectBox/MiInputSelectBox";

const DEFAULT_ZOOM_LEVEL_OPTIONS = [1, 2, 3, 4].map((value) => ({
  label: `Calendar Zoom ${value * 100}%`,
  value,
}));

export function ZoomInput({
  value,
  handleChange,
  options = DEFAULT_ZOOM_LEVEL_OPTIONS,
  className,
  name,
}: ZoomInputProps) {
  const { classes, theme, cx } = useStyles();

  return (
    <MiInputSelectBox
      value={value}
      handleChange={handleChange}
      disableNone
      name={name}
      options={options}
      menuItemStyle={{
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(0.5),
        padding: theme.spacing(0.5, 2),
        fontWeight: theme.fontWeight.semiBold,
        fontSize: theme.fontSize.medium,
      }}
      className={cx(classes.zoomController, className)}
    />
  );
}

type ZoomInputProps = {
  value?: number;
  handleChange?: (event: SelectChangeEvent<number>) => void;
  options?: { label: string; value: number }[];
  className?: string;
  name?: string;
};

const useStyles = makeStyles()((theme) => ({
  zoomController: {
    "& .MuiSelect-select": {
      padding: theme.spacing(0, 2),
      display: "flex",
      alignItems: "center",
      height: 24,
      borderRadius: theme.spacing(0.5),
      gap: theme.spacing(0.5),
      fontWeight: theme.fontWeight.semiBold,
      fontSize: theme.fontSize.medium,
    },
    "& .MuiInputBase-root": {
      borderRadius: theme.spacing(0.5),
    },
  },
}));
